import { createAction } from 'redux-actions'

export const setBlockedPathname = createAction('PROTRACKS_UNSAVED/SET_BLOCKED_PATHNAME', pathname => ({
  pathname,
}))

export const reset = createAction('PROTRACKS_UNSAVED/RESET')
